import React, { useEffect, useState, useRef } from 'react';

const isIOS = () => {
    return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
};

const isInStandaloneMode = () => (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
);

const PWAInstallPrompt = () => {
    const [isInstallable, setIsInstallable] = useState(false);
    const [showIOSGuide, setShowIOSGuide] = useState(false);
    const deferredPromptRef = useRef(null);

    useEffect(() => {
        // Android / modern browsers
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            deferredPromptRef.current = e;
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // iOS detection
        if (isIOS() && !isInStandaloneMode()) {
            setShowIOSGuide(true);
        }

        return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }, []);

    const handleInstallClick = async () => {
        if (deferredPromptRef.current) {
            deferredPromptRef.current.prompt();
            const choice = await deferredPromptRef.current.userChoice;
            if (choice.outcome === 'accepted') {
                console.log('✅ Aplikace byla nainstalována');
            } else {
                console.log('❌ Instalace byla zrušena');
            }
            deferredPromptRef.current = null;
            setIsInstallable(false);
        }
    };

    return (
        <div className="container text-center my-4">
            {isInstallable && (
                <button onClick={handleInstallClick} className="btn btn-danger">
                    📲 Nainstalovat Echo jako aplikaci
                </button>
            )}

            {showIOSGuide && (
                <div className="alert alert-danger mt-3 mx-auto" style={{ maxWidth: 500 }}>
                    <h5 className="mb-2">📱 Přidej Echo na plochu</h5>
                    <p>Na iOS klikni na <strong>„Sdílet“</strong> <i className="bi bi-box-arrow-up"></i> dole v
                        prohlížeči a vyber <strong>„Přidat na plochu“</strong>.</p>
                </div>
            )}
        </div>
    );
};

export default PWAInstallPrompt;
